import React from "react";
import PropTypes from "prop-types";
import ProfilePicture from "@govlaunch/profile-picture";
import Tag, { TagClose, TagText } from "./Tag";
import noop from "lodash/fp/noop";
import * as palette from "@govlaunch/palette";
import RawButton from "./RawButton";

export default function GovernmentTag({ government, onClose, ...props }) {
  return (
    <Tag
      onClose={onClose}
      css={{
        maxWidth: 320,
        height: 32,
        paddingLeft: 15,
        paddingRight: 15,
      }}
      {...props}
    >
      <div
        css={{
          marginRight: 10,
          display: "inline-flex",
        }}
      >
        <ProfilePicture name={government.name || government.city.name} image={government.logo} size={25} />
      </div>

      <TagText
        css={{
          color: palette.text,
          fontWeight: 500,
          fontSize: 12,
          textTransform: "uppercase",
        }}
      >
        {government.name || `${government.city.name}, ${government.city.state}`}
      </TagText>
      {onClose && (
        <RawButton
          onClick={onClose}
          tabIndex={0}
          css={{
            marginLeft: 15,
          }}
          type="button"
        >
          <TagClose />
        </RawButton>
      )}
    </Tag>
  );
}

GovernmentTag.propTypes = {
  government: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

GovernmentTag.defaultProps = {
  onClose: noop,
};
